export default "__VITE_ASSET__CwAkJmcD__"